// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"387":"d6d8bb24","467":"39fb49d9","487":"a82d5cb6","856":"64782942"}[chunkId] + ".js";
};